export default "__VITE_ASSET__ByIrGi78__"